window.MtaH5 = {
  pgv() {},
  clickStat() {},
};

export default Object.create(null);
